import { useState, useEffect } from 'react';
import api from '../services/api';

const serverUrl = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000';

// Toutes les images sont servies par le backend (uploads/ et photos_bijoux/)
const resolveImg = (path) => {
  if (!path) return '';
  return path.startsWith('/') ? `${serverUrl}${path}` : path;
};

const normalize = (p, idx) => ({
  id: p._id,
  num: idx + 1, // numéro affiché (1-indexed)
  name: p.name || '',
  type: p.type || '',
  story: p.story || '',
  status: p.status,
  stone: p.stone || '',
  origin: p.origin || '',
  size: p.size || '',
  available: p.available ?? 0,
  img: resolveImg(p.images?.[0]?.path),
  images: (p.images || []).map(i => resolveImg(i.path)).filter(Boolean),
});

export function usePieces() {
  const [pieces, setPieces] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get('/products')
      .then(res => {
        if (cancelled) return;
        setPieces(res.data.map(normalize));
      })
      .catch(err => console.error('Erreur chargement bijoux :', err))
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { pieces, loading };
}
